export default __webpack_public_path__ + "static/media/logo.de6d32da.svg";